import client from '../../base-api';

const serviceURL = '/portal/private-learning-coaching';

const portalPrivateLearningCoachingService = {

    getProtocolList(coachingId: number) {
        return client.get(`${serviceURL}/protocol-list/${coachingId}`);
    },
    getProtocol(protocolId: number) {
        return client.get(`${serviceURL}/protocol/${protocolId}`);
    },
    postProtocol(protocolData: any) {
        return client.post(`${serviceURL}/protocol-create`, protocolData);
    },
    putProtocol(protocolData: any, protocolId: number) {
        return client.put(`${serviceURL}/protocol-update/${protocolId}`, protocolData);
    },
    postProtocolNote(noteData: any) {
        return client.post(`${serviceURL}/protocol-note-create`, noteData);
    },
    putProtocolNote(noteData: any, protocolId: number) {
        return client.put(`${serviceURL}/protocol-note-update/${protocolId}`, noteData);
    },
    protocolDelete(protocolId: number) {
        return client.delete(`${serviceURL}/protocol-delete/${protocolId}`);
    },
    getSumUnitsDoneForModule(id: number, moduleId: number, meetingId = '') {
        return client.get(`${serviceURL}/get-sun-units-done-for-module/${id}/${moduleId}/${meetingId}`);
    },
}

export default portalPrivateLearningCoachingService;